import { createSlice } from '@reduxjs/toolkit';
import {
  getInventoriesReducers,
  getInventoriesOverviewReducers,
  deleteInventoryReducers,
  downloadInventoryReducers,
  uploadInventoryReducers,
  deleteInventoriesByFilterReducers,
  searchInventoryReducers,
} from './inventories.reducers';

const initialState = {
  inventory: null,

  inventories: [],
  totalInventories: 0,
  totalPages: 0,
  currentPage: 1,

  getOverviewStatus: 'idle',
  overview: {
    totalInventories: 0,
    totalStorageSize: '0 Bytes',
    currentDayInventories: 0,
    pendingChunking: 0,
  },

  getInventoriesStatus: 'idle',
  getInventoryStatus: '',
  updateInventoryStatus: '',

  deleteInventoryStatus: 'idle',
  deleteInventoriesByFilterStatus: 'idle',
  downloadInventoryStatus: 'idle',

  uploadInventoryStatus: 'idle',

  // Search state
  searchResults: [],
  searchTotalCount: 0,
  searchTotalPages: 0,
  searchCurrentPage: 1,
  searchInventoryStatus: 'idle',

  error: null,
};

const inventoriesSlice = createSlice({
  name: 'inventories',
  initialState,
  reducers: {
    clearSearchResults: (state) => {
      state.searchResults = [];
      state.searchTotalCount = 0;
      state.searchTotalPages = 0;
      state.searchCurrentPage = 1;
      state.searchInventoryStatus = 'idle';
    },
  },
  extraReducers: (builder) => {
    getInventoriesReducers(builder);
    getInventoriesOverviewReducers(builder);
    deleteInventoryReducers(builder);
    deleteInventoriesByFilterReducers(builder);
    downloadInventoryReducers(builder);
    uploadInventoryReducers(builder);
    searchInventoryReducers(builder);
  },
});

export const { clearSearchResults } = inventoriesSlice.actions;
export default inventoriesSlice.reducer;
